import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import union from 'lodash/union';

import {
  UPDATE_RESTORATION_STATE,
  CLEAR_RESTORATION_STATE,
  ADD_CLEANUP_ID,
} from 'actions/backRestoration';

const INITIAL_STATE = Immutable({ restorationState: {}, cleanUpIds: [] });

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case UPDATE_RESTORATION_STATE: {
      return state.merge(
        {
          restorationState: { [action.meta.id]: action.payload },
        },
        { deep: true },
      );
    }
    case CLEAR_RESTORATION_STATE:
      return INITIAL_STATE;
    case ADD_CLEANUP_ID:
      return state.merge({
        cleanUpIds: union([action.payload.id], state.cleanUpIds),
      });
    default:
      return state;
  }
};
